<template>
    <div class="h-full w-full flex flex-col sm:flex-row shadow-2xl border rounded-lg">
        <div class="xl:h-72 2xl:h-56 w-full sm:w-72 flex-shrink-0">
            <div class="h-full w-full bg-indigo-300 animate-pulse rounded-tl-lg rounded-tr-lg sm:rounded-tr-none rounded-bl-none sm:rounded-bl-lg"></div>
        </div>
        <div class="flex-grow bg-white p-4 flex flex-col justify-between leading-normal rounded-bl-lg sm:rounded-bl-none rounded-br-lg rounded-tr-none sm:rounded-tr-lg">
            <div class="mb-6 xl:mb-8">
                <div class="h-8 bg-gray-600 animate-pulse mb-8"></div>
                <p class="h-4 bg-gray-300 animate-pulse mb-4"></p>
                <p class="h-4 bg-gray-300 animate-pulse mb-4"></p>
                <p class="h-4 bg-gray-300 animate-pulse"></p>
            </div>
            <div class="flex justify-start items-center">
                <div class="flex-shrink-0 mr-2 sm:mr-4">
                    <div class="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-indigo-300 animate-pulse"></div>
                </div>
                <div class="flex-grow flex flex-col">
                    <div class="bg-gray-400 animate-pulse h-2 w-1/4 mb-2"></div>
                    <div class="bg-gray-300 animate-pulse h-2 w-1/5"></div>
                </div>
            </div>
        </div>
    </div>
</template>